module.exports = {
    Description: {
        StaticInfo: `<p>Hydraulic fracturing can be performed in new and old wells.</p>
      <p>In order to stimulate old wells, the operator must to carry out a pre-selection of candidates. Several factors must be considered, among them: the well current status, formation damage, gas production,  oil production, water production, associated reserves and the recovery factor. Subsequently, a review of the mechanical condition for each well is performed.</p>
      <p>When the option is to drill a new well and stimulate it with hydraulic fracturing, this must be designed, and the completion process must be properly monitored. This refers to the operations and techniques to complete a newly drilled well so that fluids can be produced from, or injected into, the reservoir in an efficient and safe manner.</p>
      <p>In any case, the design and operations must be performed correctly from the outset, to ensure that the productivity potential of the field is obtained.</p>
      `,
        SectionsInfo: []
    },
    Overview: {
        StaticInfo: `<p>In a <strong>New Well</strong>, the completion design must consider the following elements:</p>`,
        SectionsInfo: [{
                title: "Reservoir parameters",
                content: `
          <ul>
          <li>Produced reservoir, fluid type: oil, gas, condensate, or water</li>
          <li>Reservoir-fluid pressure, volume, temperature analysis—density, viscosity, paraffins, asphaltenes, and bubble point</li>
          <li>Geomechanical properties: minimum, intermediate, and maximum stress values; stress orientation with respect to the wellbore; mechanical rock properties, including Poisson’s ratio and Young’s modulus</li>
          <li>Reservoir pressure and expected pressure decline</li>
          <li>Reservoir drive mechanism</li>
          <li>Single or multiple reservoirs/producing zones and total producing height</li>
          <li>Potential producing rates over the life of the well</li>
          <li>Artificial-lift requirements</li>
          <li>Sand-control requirements</li>
          <li>Secondary-oil-recovery requirements</li>
          <li>Enhanced-recovery requirements</li>
          </ul>
          `
            },
            {
                title: "Mechanical considerations",
                content: `
          <ul>
          <li>Tubulars: both casing and tubing</li>
          <li>Size for optimal production of fluids</li>
          <li>Size and strength required for pumping hydraulic fracturing treatments</li>
          <li>Downhole tools and equipment</li>
          <li>Functional requirements of packers, inflow-control devices, nipples, and safety valves</li>
          <li>Operating conditions</li>
          <li>Metallurgy, elastomers, electronics, and other materials exposure to reservoir fluids, temperature, and pressure</li>
        </ul>
          `
            },
            {
                title: "Safety and regulatory",
                content: `
        <ul>
      <li>That components exceed safety requirements by a reasonable safety factor</li>
      <li>That overall design meets or exceeds all governmental regulations</li>
      <li>That environmental standards are met</li>
    </ul>
        `
            },
            {
                title: "Old Wells",
                content: `<p>A good practice for fracking operations is to select <strong>good wells rather than poor producers</strong>. However, having no other choices, other types of wells (with or without mechanical difficulties) can be considered. The well and reservoir condition must allow maximum sustained production. The mechanical diagrams of the candidate wells MUST BE THOROUGHLY CHECKED and in some cases the operator must modify the fracture treatment in accordance  with limitations imposed by the physical old well configuration.</p>`
            },
            {
                title: "Qualitative well(s) indicator",
                content: `
        <p>When the time comes to choose among several wells, to select which are the most appropriate or convenient to choose, the factors with the greatest incidence in the decision were grouped into Four Impact Blocks.</p>
    <p>Each Block is conformed by several pertinent items or elements.</p>
    <p>For each element, the level of attractiveness or “value or impact” is identified (objectively-subjectively depending on its nature) in the selection process.</p>
    <p>Additionally, the different Blocks are grouped into an Objective Function and each Block can be assigned a weight, f1 to f4, to represent the "interest or inclination of the user" as adequately as possible.</p>
    <p>The weighting factors (basically percentages of the Consolidated Indicator II, should add up to 1.0 or 100%.)</p>
    <p>The four Blocks that make up the Indicator and the elements that make up each Block, are for now the following:</p>
    <ul>
      <li>Block 1 - Probability of Success (PE)</li>
      <ul>
        <li>1.1. Mechanical Complexity (by the mechanical condition of the well)</li>
        <li>1.2. Operational Complexity (due to the operational nature)</li>
        <li>1.3. Logistical complexity (geographic, environmental, regulatory)</li>
      </ul>
    </ul>
    <ul>
      <li>Block 2 - Rate and Reserves (TR)</li>
      <ul>
        <li>2.2. Rate of oil or gas assigned to the job in absolute values</li>
        <li>2.3. Reserves associated to the job in absolute values</li>
      </ul>
    </ul>
    <ul>
      <li>Block 3 - Total Costs and per Unit Incremental Rate and Assigned Reserves (C)</li>
      <ul>
        <li>3.1. Total Cost of job (absolute value) Maximum exposure or risk of funds</li>
        <li>3.2. Cost per unit of anticipated incremental rate (US $ / MMSCF/D or STB/D)</li>
        <li>3.3. Cost per incremental unit of anticipated reserves (US $ /MMSCF/D or STB/D)</li>
      </ul>
    </ul>
    <ul>
      <li>Block 4 - Economic Indicators (IE)</li>
      <ul>
        <li>4.1 NPV or NPV in absolute monetary units</li>
        <li>4.2 Internal Rate of Return or IRR in%</li>
      </ul>
    </ul>
    <p>Objective Function: IIS = (PE) x f1 + (TR) x f2 + (C) x f3 + (IE) x f4</p>
    `,

            }
        ]
    },
    Inputs: {
        StaticInfo: `<p>In this section our purpose is to help the client with the selection of candidate wells. Please consider to upload the completion history, rehabilitation events and mechanical diagrams for each prospective well; as well a  other relevant data, such as: Well current status, cement condition, formation damage, gas production, oil production, water production, associated reserves and the current recovery factor.</p>
    <p>The EGEP consultant will help you analyze and preselect the well(s) that have the best conditions to apply hydraulic fracturing.</p>
    `,
        SectionsInfo: []
    },
    Deliverables: {
        StaticInfo: `<p>In this section the EGEP consultant will analyze and discuss his opinion about the well(s) that have the best conditions to become a hydraulic fracturing candidate, and will provide a report with his analysis, conclusions and recommendations based on his opinion and on the Qualitative Well(s) Indicator.</p>
      
      `,
        SectionsInfo: []
    }
}